import React from "react";

const PLAY_STORE_URL = [
  "https://play.google.com/store/apps/details?id=com.emergent.tickerphoneapp.a3laqn",
  "&pcampaignid=web_share",
].join("");
const EVENTVEXA_ICON_URL = [
  "https://play-lh.googleusercontent.com/",
  "AbrQg4PmrLb991rJTcV1d-6kX8yiKQTvIGu7xqNvACAG2vbrkBU54edjSqrMTD6hNvWvW4Cw3u2zKxSsWnpB=w240-h480-rw",
].join("");

export const PlayStoreLink = ({ testId, footer = false }) => {
  const shape = footer ? "rounded-lg" : "rounded-full";
  const classes = [
    "inline-flex items-center gap-3 border border-foreground/20 bg-card px-3 py-2 text-left",
    "shadow-sm transition-[border-color,transform,background-color] hover:-translate-y-0.5",
    "hover:border-primary hover:bg-primary/5",
    shape,
  ].join(" ");

  return (
  <a
    href={PLAY_STORE_URL}
    target="_blank"
    rel="noreferrer"
    data-testid={testId}
    className={classes}
  >
    <img
      src={EVENTVEXA_ICON_URL}
      alt="EventVexa app icon"
      className="h-9 w-9 rounded-lg object-cover"
    />
    <span className="leading-tight">
      <span className="block text-[10px] font-medium uppercase text-muted-foreground">
        Get it on
      </span>
      <span className="block text-sm font-semibold text-foreground">Google Play</span>
    </span>
  </a>
  );
};